import {useEffect,useState} from "react";

const storageKey="avwakin.outreach.discovery.v1";
export const discoveryLifetime=29*24*60*60*1000;
const initial=()=>({values:{provider:"youtube",keywords:"indie fantasy book reviews",min_audience:"",max_audience:"",name:""},results:null,expiresAt:null});
function restore(){
 try{
  const stored=JSON.parse(window.sessionStorage.getItem(storageKey));
  if(stored&&stored.expiresAt>Date.now()&&stored.expiresAt<=Date.now()+discoveryLifetime&&Array.isArray(stored.results?.results)&&stored.values&&["youtube","podcastindex"].includes(stored.values.provider))return stored;
  window.sessionStorage.removeItem(storageKey);
 }catch{/* Storage is optional; the current page still keeps the session in memory. */}
 return initial();
}
export default function useOutreachDiscoverySession(){
 const[session,setSession]=useState(restore);
 useEffect(()=>{try{if(session.results)window.sessionStorage.setItem(storageKey,JSON.stringify(session));else window.sessionStorage.removeItem(storageKey);}catch{/* Fall back to in-memory state if storage is unavailable or full. */}},[session]);
 useEffect(()=>{if(!session.expiresAt)return;const timer=setInterval(()=>{if(Date.now()>=session.expiresAt)setSession(initial());},60000);return()=>clearInterval(timer);},[session.expiresAt]);
 return[session,setSession];
}
